<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-03-13 23:46:51
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <TableScrollSlider :table-ref="$refs.multipleTable" />
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">任务列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="任务名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入任务名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发布人姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.creator_name"
                    placeholder="请输入发布人名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发布人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入发布人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择任务状态"
                  >
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="待发布" value="1"></el-option>
                    <el-option label="发布中" value="2"></el-option>
                    <el-option label="已收单" value="3"></el-option>
                    <el-option label="实做中" value="4"></el-option>
                    <el-option label="已取消" value="5"></el-option>
                    <el-option label="已结算" value="6"></el-option>
                    <el-option label="已关闭" value="9"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.cadeVerifyStatus"
                    placeholder="请选择支付状态"
                  >
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <!-- <el-button type="primary" @click="exportToExcel()" class="btn"
          >任务excel导出</el-button
        > -->
        <el-button type="primary" @click="exportList(1)" class="btn"
          >任务excel导出</el-button
        >
        <el-button type="primary" @click="exportList(2)" class="btn"
          >实做人员明细导出</el-button
        >
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="jobNo" label="单号" align="center" width="200">
          </el-table-column>
          <el-table-column prop="creatorName" label="发布人" align="center">
          </el-table-column>
          <el-table-column label="任务名称" align="center" width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.title }}
                <div slot="reference" class="name-wrapper">
                  <div class="omit">{{ scope.row.title }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="发布人手机号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="belongCompanyName"
            label="归属"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="服务时长" align="center" width="80">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <span>{{ scope.row.jobStart }}至</span>
                <span>{{ scope.row.jobEnd }}</span>
                <div slot="reference" class="name-wrapper">
                  <div class="omit">{{ (scope.row.hour * 60) | maxTime }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="任务时间" align="center" width="190">
            <template slot-scope="scope">
              <div>{{ scope.row.jobStart }}</div>
              <div>{{ scope.row.jobEnd }}</div>
            </template>
          </el-table-column>
          <el-table-column label="总金额" align="center" width="100">
            <template slot-scope="scope">
              <span>￥{{ scope.row.price | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请人" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.readiesNum }}/</span>
              <span>{{ scope.row.membersNum }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="手机号" align="center" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="创建时间" align="center" width="190">
            <template slot-scope="scope">
              <span>{{ scope.row.gmtCreate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="yellowColor" v-if="scope.row.status == 0"
                >待支付</span
              >
              <span class="blueColor" v-if="scope.row.status == 1">待发布</span>
              <span class="blueColor" v-if="scope.row.status == 2">发布中</span>
              <span class="blueColor" v-if="scope.row.status == 3">已收单</span>
              <span class="blueColor" v-if="scope.row.status == 4">实做中</span>
              <span class="redColor" v-if="scope.row.status == 5">已取消</span>
              <span class="greenColor" v-if="scope.row.status == 6"
                >已结算</span
              >
              <span class="greenColor" v-if="scope.row.status == 8"
                >已完成</span
              >
              <span class="redColor" v-if="scope.row.status == 9">已关闭</span>
            </template>
          </el-table-column>
          <el-table-column label="结算状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.cashType == 0"
                >未结算</span
              >
              <span class="blueColor" v-if="scope.row.cashType == 1"
                >结算中</span
              >
              <span class="greenColor" v-if="scope.row.cashType == 2"
                >已结算</span
              >
            </template>
          </el-table-column>
          <el-table-column label="支付方式" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.payWay == 0">钱包</span>
              <span v-if="scope.row.payWay == 2">银行卡</span>
              <span v-if="scope.row.payWay == 3">支付宝</span>
              <span v-if="scope.row.payWay == 4">微信</span>
            </template>
          </el-table-column>
          <el-table-column label="退款状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.refundStatus == 0">无退款</span>
              <span class="blueColor" v-if="scope.row.refundStatus == 1"
                >处理中</span
              >
              <span class="greenColor" v-if="scope.row.refundStatus == 2"
                >已完成</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="refundAt"
            label="退款时间"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="支付状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="yellowColor" v-if="scope.row.payStatus == 0"
                >待支付</span
              >
              <span class="greenColor" v-if="scope.row.payStatus == 1"
                >已支付</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="160"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>

                <div
                  class="operateBtn"
                  @click="handleEdit(scope.row)"
                  v-if="
                    scope.row.status == 2 ||
                    (scope.row.status == 4 &&
                      scope.row.members_num > scope.row.readies_num)
                  "
                >
                  派单
                </div>
                <div
                  class="operateBtn"
                  @click="goDetail1(scope.row)"
                  v-if="scope.row.status == 4 || scope.row.status == 6"
                >
                  实做详情
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="派单设置"
      :visible.sync="dialogFormVisible1"
      width="800px"
    >
      <el-form ref="ruleForm" :model="ruleForm2">
        <el-row :gutter="4">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="ruleForm2.name"
                placeholder="请输入名称"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="ruleForm2.phone"
                placeholder="请输入手机号"
                @focus="clearData"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份状态">
              <el-select v-model="ruleForm2.status" placeholder="请选择">
                <el-option
                  v-for="item in tableData2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" @click="getUserList()" class="btn"
                >查询</el-button
              >
              <el-button @click="resetForm1()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="margin-bottom: 20px">搜索总数：{{ tableData1.length }}</div>
      <el-table
        ref="singleTable"
        :data="tableData1"
        style="width: 100%"
        highlight-current-row
        @current-change="selectItem"
        max-height="250"
      >
        <el-table-column align="center" width="50">
          <template slot-scope="scope">
            <div
              :class="[scope.row.id == selectUserID ? 'select' : 'noselect']"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">{{
            scope.row.accountType == 0
              ? scope.row.companyName
              : scope.row.cardName
          }}</template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">{{
            scope.row.accountType == 0
              ? "企业"
              : scope.row.accountType == 1
              ? "企业员工"
              : "临勤"
          }}</template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 30px; text-align: right">
        <el-button type="primary" @click="allocation()" class="btn"
          >派单</el-button
        >
        <el-button @click="resetForm2()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import * as XLSX from "xlsx";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        creator_name: "",
        phone: "",
        time: "",
        time1: "",
        wxVerifiedStatus: "",
        cadeVerifyStatus: "",
        status: "",
        jobNo: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      ruleForm2: {
        name: "",
        phone: "",
        status: "",
      },
      dialogFormVisible1: false,
      allocationId: "",
      selectUserID: "",
      tableData1: [],
      tableData2: [
        { label: "企业", value: 0 },
        { label: "临勤", value: 2 },
      ],
      multipleTable: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    exportToExcel() {
      // 定义数据
      const data = [
        ["姓名", "年龄", "职业"],
        ["张三", 28, "工程师"],
        ["李四", 35, "设计师"],
        ["王五", 22, "教师"],
      ];

      // 将数据转换为工作表
      const ws = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // 生成Excel文件并使用Blob导出
      const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });
      const blob = new Blob([this.s2ab(wbout)], {
        type: "application/octet-stream",
      });

      // 创建下载链接并触发下载
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "example.xlsx";
      a.click();
      URL.revokeObjectURL(url); // 释放URL对象
    },
    s2ab(s) {
      // 将字符串转换为ArrayBuffer，用于Blob构造函数
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportList(key) {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = [];
          if (this.multipleTable.length != 0) {
            for (var i = 0; i < this.multipleTable.length; i++) {
              arr.push(this.multipleTable[i].id);
            }
          }
          let param = {
            queryParams: [],
            ids: arr,
          };
          if (this.ruleForm.name != "") {
            param.queryParams.push({
              name: "title",
              type: "input",
              value: this.ruleForm.name,
            });
          }
          if (this.ruleForm.creator_name != "") {
            param.queryParams.push({
              name: "creator_name",
              type: "input",
              value: this.ruleForm.creator_name,
            });
          }
          if (this.ruleForm.jobNo != "") {
            param.queryParams.push({
              name: "job_no",
              type: "input",
              value: this.ruleForm.jobNo,
            });
          }
          if (this.ruleForm.cadeVerifyStatus != "") {
            param.queryParams.push({
              name: "pay_status",
              type: "select",
              values: [{ itemKey: this.ruleForm.cadeVerifyStatus }],
            });
          }
          if (this.ruleForm.status != "") {
            param.queryParams.push({
              name: "status",
              type: "select",
              values: [{ itemKey: this.ruleForm.status }],
            });
          }
          if (this.ruleForm.time != "") {
            param.queryParams.push({
              name: "real_action_at",
              type: "dateRange",
              fromValue: this.ruleForm.time,
              toValue: this.ruleForm.time1,
            });
          }
          if (this.ruleForm.phone != "") {
            param.phone = this.ruleForm.phone;
          }
          let str = "";
          if (key == 1) {
            str = "/admapi/job/jobexport";
          } else {
            str = "/admapi/job/jobworkexport";
          }
          this.$axios
            .post(str, param, { responseType: "blob" })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    goDetail(val) {
      window.open(
        this.$router.resolve({
          path: "/taskDetail",
          query: {
            id: val.id,
          },
        }).href,
        "_blank"
      );
    },
    goDetail1(val) {
      window.open(
        this.$router.resolve({
          path: "/Implementation",
          query: {
            id: val.jobNo,
          },
        }).href,
        "_blank"
      );
    },
    handleEdit(val) {
      this.allocationId = val.jobNo;
      this.taskId = val.id;
      this.getUserList();
      this.dialogFormVisible1 = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.phone = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.ruleForm.status = "";
      this.ruleForm.jobNo = "";
      this.ruleForm.cadeVerifyStatus = "";
      this.ruleForm.creator_name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "title",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.creator_name != "") {
        param.queryParams.push({
          name: "creator_name",
          type: "input",
          value: this.ruleForm.creator_name,
        });
      }
      if (this.ruleForm.jobNo != "") {
        param.queryParams.push({
          name: "job_no",
          type: "input",
          value: this.ruleForm.jobNo,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      if (this.ruleForm.time != "") {
        param.queryParams.push({
          name: "real_action_at",
          type: "dateRange",
          fromValue: this.ruleForm.time,
          toValue: this.ruleForm.time1,
        });
      }
      if (this.ruleForm.cadeVerifyStatus != "") {
        param.queryParams.push({
          name: "pay_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.cadeVerifyStatus }],
        });
      }
      if (this.ruleForm.phone != "") {
        param.phone = this.ruleForm.phone;
      }
      this.$axios
        .post(`/admapi/job/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    resetForm2() {
      this.selectUserID = "";
      this.allocationId = "";
      this.taskId = "";
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.dialogFormVisible1 = false;
    },
    allocation() {
      if (!this.selectUserID) {
        this.$message({
          message: "请选择保安",
          type: "warning",
        });
        return;
      }
      let param = {
        jobId: this.taskId,
        bodygurardId: this.selectUserID,
      };
      this.$axios
        .post(`/admapi/dispatchjob/add`, param)
        .then(({ data }) => {
          this.$message({
            message: "派单成功",
            type: "success",
          });
          this.getList();
        })
        .catch()
        .finally(() => {
          this.selectUserID = "";
          this.allocationId = "";
          this.taskId = "";
          this.dialogFormVisible1 = false;
        });
    },
    handleChange(val) {
      this.ruleForm2.status = val[val.length - 1];
    },
    selectItem(val) {
      this.selectUserID = val == null ? "" : val.id;
    },
    resetForm1() {
      this.selectUser = {};
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.getUserList();
    },
    clearData() {
      this.selectUserID = "";
      this.$refs.singleTable.clearSelection();
    },
    getUserList() {
      let param = {
        page: 1,
        pageSize: 1000,
        accountType: this.ruleForm2.status,
        cardName: this.ruleForm2.name,
        phone: this.ruleForm2.phone,
        jobNo: this.allocationId,
        queryParams: [],
      };
      if (this.allocationId != "") {
        param.queryParams.push({
          name: "iob_no",
          type: "select",
          values: [
            {
              itemKey: this.allocationId,
            },
          ],
        });
      }
      // if (this.ruleForm2.phone != "") {
      //   param.queryParams.push({
      //     name: "phone",
      //     type: "input",
      //     value: this.ruleForm2.phone
      //   });
      // }
      // if (this.ruleForm2.status != "") {
      //   param.queryParams.push({
      //     name: "account_type",
      //     type: "select",
      //     values: [
      //       {
      //         itemKey: this.ruleForm2.status
      //       }
      //     ]
      //   });
      // }
      this.$axios
        .post(`/admapi/bodyguard/dispathMemberlist`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
          this.selectUserID = "";
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}
.noselect {
  width: 10px;
  height: 10px;
  border: #165dff 1px solid;
  border-radius: 10px;
}
</style>
